import { registerInterest as submitInterest } from '../api'

export function useInvestorRelationsPublicAPI() {
  return {
    registerInterest: (
      companySlug: string,
      name: string,
      email: string,
      accountType: 'investor' | 'lender'
    ) => submitInterest(companySlug, { name, email, accountType }),
  }
}
